import {
    apiRequest,
    HDdetail
} from "../../../../../services/adapters/kepegawaian/hukdisService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", HDdetail, {
            params: query
        }, true)
    }

}

export default DetailRepository